module.exports = __webpack_public_path__ + "img/icon-sb-delete-address-illustration-200x200.ce2ef0b.svg";